// ══════════════════════════════════════════════════════════════
// COMPASS – Management Company Actions
// ══════════════════════════════════════════════════════════════
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ManagementCompanyDto } from '../../api/models/management-company-dto';
import { PermissionDto } from '../../api/models/permission-dto';

export const ManagementCompanyActions = createActionGroup({
  source: 'Management Company',
  events: {
    'Load Companies': emptyProps(),
    'Load Companies Success': props<{ companies: ManagementCompanyDto[] }>(),
    'Load Companies Failure': props<{ error: string }>(),
    'Select Company': props<{ companyId: string }>(),
    'Clear Companies': emptyProps(),
    'Load Permissions': props<{ companyId: string }>(),
    'Load Permissions Success': props<{ permissionDto: PermissionDto }>(),
    'Load Permissions Failure': props<{ error: string }>(),
  },
});
